module.exports = __webpack_public_path__ + "static/media/title-tc.70dd30e3.png";